import { useEffect, useState } from 'react';

import type { SiteId } from '@hotjar/site';
import { useGate } from '@hotjar/allowances';

import { GATE_FEEDBACK } from '../domains/webhooks/feature';
import { getFeedbackSettings, getSurveySettings } from '../domains/webhooks/api';
import type { WebhooksSettingsDto, WidgetType } from '../domains/webhooks/api';

type WidgetId = number;

type UseWebhooksForwardingSettingsProps = {
  siteId: SiteId;
  widgetType: WidgetType;
  widgetId: WidgetId;
  disabled: boolean;
};

export function useWebhooksForwardingSettings({
  siteId,
  widgetType,
  widgetId,
  disabled,
}: UseWebhooksForwardingSettingsProps): WebhooksSettingsDto | null {
  const [settings, setSettings] = useState<WebhooksSettingsDto | null>(null);
  const canUseIntegration = useGate(GATE_FEEDBACK, { id: String(siteId), type: 'site' });

  useEffect(() => {
    (async () => {
      // If feature flag disabled or site is not in the right plan, don't do anything
      if (!disabled && canUseIntegration) {
        const getForwardingSettings =
          widgetType === 'poll' ? getSurveySettings : getFeedbackSettings;

        const s = await getForwardingSettings(String(siteId), String(widgetId));
        setSettings(s);
      }
    })();

    return () => {
      // Cancel request
    };
  }, [siteId, widgetType, widgetId, canUseIntegration, disabled]);

  return settings;
}
